
/**
 * Extrai a UF dos dois primeiros caracteres do documento.
 * @param {string} document
 * @returns {string}
 */
export const extractUfFromDocument = (document) => {
  if (!document) return '';
  return document.length >= 2 ? document.substring(0, 2) : '';
};

/**
 * Extrai o número do documento a partir do terceiro caractere.
 * @param {string} document
 * @returns {string}
 */
export const extractDocumentNumber = (document) => {
  if (!document) return '';
  return document.length >= 2 ? document.substring(2) : '';
};
